import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { NextAppErrorDetails } from '@zurich-framework/nextapp/components';
import { useAppInstance } from '@zurich-framework/nextapp/hooks';
import { useBaseConfig, useBusinessProcessId } from '@zurich/common/contexts';
import { useTranslation } from '@zurich/common/hooks';
import { Container, NoSSR, Typography } from '@zurich/ui/legacy/components';
import { useAppImage } from '@zurich/ui/legacy/hooks';
import { styled } from '@zurich/ui/legacy/utils';
import { InfoCard } from '../InfoCard';
const MessageStyled = styled('p')(() => ({}));
const BusinessProcessIdStyled = styled('p')(() => ({}));
const DetailsContainerStyled = styled('div')(({ theme }) => ({
    padding: theme.spacing(2),
}));
export function CustomError({ error, image, showDetails }) {
    const { t } = useTranslation();
    const config = useBaseConfig();
    const { createErrorObject } = useAppInstance();
    const businessProcessId = useBusinessProcessId();
    const AppImage = useAppImage();
    const primaryError = error.className !== 'FetchApiError'
        ? error
        : (error.findParentByCallback((parent) => parent.className !== 'FetchApiError', createErrorObject) ?? error);
    const details = config.debug || showDetails;
    const title = primaryError.getTranslatedType(t);
    const message = primaryError.getTranslatedMessage(t);
    return (_jsx(Container, { spacing: 5, children: _jsx(InfoCard, { title: _jsx(Typography, { variant: "h4", children: title }), description: _jsxs("div", { children: [message && _jsx(MessageStyled, { children: message }), businessProcessId && (_jsx(NoSSR, { children: _jsxs(BusinessProcessIdStyled, { children: [_jsx("b", { children: "Business Process Id:" }), " ", businessProcessId] }) })), details ? (_jsx(DetailsContainerStyled, { children: _jsx(NextAppErrorDetails, { error: error }) })) : null] }), illustration: image && _jsx(AppImage, { src: image, alt: title }) }) }));
}
